<div class="loading-container">
    <mat-spinner class="loading" mode="indeterminate"></mat-spinner>
</div>